module.exports = __webpack_public_path__ + "static/img/202508051536223135.fc68139.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/202508051536223135.png
// module id = 2x+B
// module chunks = 1